import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Layout from "containers/Layout";
import "react-dropdown/style.css";

import { Headersub } from "../../GenericComponent/HeaderSub/headersub";
import { TableList } from "./TableList";
import { SearchBar } from "./SearchBar";
import TatToanChoDuyetApi from "../../../service/tatToanChoDuyetApi";
import LayoutV2 from "containers/LayoutV2";

export const TatToanChoDuyet = () => {
  const initPhanQuyen = {
    tattoanchoduyet: false,
    tattoanchoduyet_suachoduyet: false,
    tattoanchoduyet_xoachoduyet: false,
  };
  const initData = {
    List: [],
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  const dataSearch = useSelector((state) => state.dataSearchTatToanChoDuyet);
  const [dataDanhSach, setDataDanhSach] = useState(initData);
  useEffect(() => {
    document.title = "Tất toán chờ duyệt | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
    SearchDanhSach();
  }, []);

  const SearchDanhSach = () => {
    TatToanChoDuyetApi.danhSachTatToanChoDuyet({
      customerName: dataSearch.customerName,
      status: dataSearch.status,
      pageIndex: dataSearch.pageIndex,
      pageSize: dataSearch.pageSize,
    }).then((response) => {
      setDataDanhSach(response.data);
    });
  };

  const LoadPhanQuyen = () => {
    TatToanChoDuyetApi.phanQuyenTatToanChoDuyet().then((response) => {
      setPhanQuyen({
        ...phanQuyen,
        tattoanchoduyet: response.data.tattoanchoduyet,
        tattoanchoduyet_suachoduyet: response.data.tattoanchoduyet_suachoduyet,
        tattoanchoduyet_xoachoduyet: response.data.tattoanchoduyet_xoachoduyet,
      });
    });
  };

  return (
    <LayoutV2>
      {phanQuyen.tattoanchoduyet && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-quan-ly-tai-san.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Tất toán chờ duyệt</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    {<SearchBar SearchDanhSach={SearchDanhSach}></SearchBar>}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {
            <TableList
              SearchDanhSach={SearchDanhSach}
              dataDanhSach={dataDanhSach}
              phanQuyen={phanQuyen}
            />
          }
        </div>
      )}
      {!phanQuyen.tattoanchoduyet && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <Headersub title="Tất toán chờ duyệt" icon1="fas fa-donate" />
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
